import script from "./TestStartButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TestStartButton.vue?vue&type=script&setup=true&lang=js"

import "./TestStartButton.vue?vue&type=style&index=0&id=4dd32feb&lang=scss&scoped=true"

import exportComponent from "D:\\Git\\monetwareProjects\\kunqu-opera-test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd32feb"]])

export default __exports__